// Libraries
import React from 'react';

// Components
import { CardBlock, CardText } from 'Components/flowChart/components/NodePreview/components/styled';

// Types
import { IMetadata } from 'Components/flowChart/components/NodePreview/components/NodeDestination/types';
import { INodePreviewProps } from 'Components/flowChart/components/NodePreview/types';

// Utils
import { getObjectPropSafely } from 'Utils';

const PATH = 'components/components/flowChart/components/Card/components/NodeWaitEvent/index.tsx';

export interface INodeDestination extends INodePreviewProps<IMetadata> {}

const NodeDestination: React.FC<INodeDestination> = (props) => {
	try {
		const {
			node: { metadata },
			lookupData,
		} = props;
		const { campaignInfo, destinationId, variantIds } = metadata;
		const destinationName = getObjectPropSafely(
			() => lookupData!.destinations[destinationId].destination_name,
			destinationId
		);

		return (
			<>
				<CardBlock>
					<CardText>{`Campaign name: ${campaignInfo?.campaign_name}`}</CardText>
					<CardText>
						{`Use destination: ${destinationName}`}
					</CardText>
				</CardBlock>
				<CardBlock>
					<CardText>{`With ${variantIds.length} variant(s)`}</CardText>
				</CardBlock>
			</>
		);
	} catch (e) {
		props.onError?.(e, {
			component: PATH,
			action: 'render -> NodeDestination',
			args: { props },
		});

		return null;
	}
};

export default NodeDestination;
